import React from 'react';
import { Button } from 'reactstrap';

import HelpPopupsContainer from '../../../containers/helpPopupsContainer';

class HelpButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openPopUp: false,
      isDisabled: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.title &&
      this.props.question &&
      this.props.title === 'Report Question' &&
      this.props.question.id !== prevProps.question.id
    ) {
      this.setState({ isDisabled: false });
    }
  }

  handleClick = () => {
    this.setState({ openPopUp: true });
  };

  handleClosePopUp = () => {
    this.setState({ openPopUp: false });
  };

  disabledButton = () => {
    this.setState({ isDisabled: true });
  };

  render() {
    const { title } = this.props;
    const { openPopUp, isDisabled } = this.state;
    return (
      <div>
        <Button
          color="link"
          block
          className="relevant-card help text-center"
          onClick={this.handleClick}
          disabled={isDisabled && title === 'Report Question'}
        >
          {title}
          <i className="icon-alert_circle" />
        </Button>
        <HelpPopupsContainer
          isOpen={openPopUp}
          handleClosePopUp={this.handleClosePopUp}
          disabledButton={this.disabledButton}
          title={title}
          question={this.props.question}
        />
      </div>
    );
  }
}

HelpButton.defaultProps = {
  title: 'Help',
};

export default HelpButton;
